<div class="classification-new">
  <div class="classification-new__header">
    <h3>Classification</h3>
    <div class="classification-new__header-right">
      <a class="collapse" (click)="expandCollapseAll()">
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M14.0592 4.68844H11.642L14.7245 1.60597C14.9009 1.42954 15 1.19026 15 0.940755C15 0.691251 14.9009 0.451966 14.7245 0.275541C14.548 0.099115 14.3087 0 14.0592 0C13.8097 0 13.5705 0.099115 13.394 0.275541L10.3116 3.34864V0.940755C10.3116 0.692268 10.2129 0.453958 10.0371 0.278252C9.86144 0.102545 9.62313 0.00383364 9.37464 0.00383364C9.12615 0.00383364 8.88785 0.102545 8.71214 0.278252C8.53643 0.453958 8.43772 0.692268 8.43772 0.940755V5.62536C8.43772 5.87385 8.53643 6.11215 8.71214 6.28786C8.88785 6.46357 9.12615 6.56228 9.37464 6.56228H14.0592C14.3077 6.56228 14.546 6.46357 14.7217 6.28786C14.8975 6.11215 14.9962 5.87385 14.9962 5.62536C14.9962 5.37687 14.8975 5.13856 14.7217 4.96286C14.546 4.78715 14.3077 4.68844 14.0592 4.68844ZM5.62696 8.43612H0.942353C0.693867 8.43612 0.455557 8.53483 0.279851 8.71054C0.104144 8.88625 0.00543259 9.12456 0.00543259 9.37304C0.00543259 9.62153 0.104144 9.85984 0.279851 10.0355C0.455557 10.2113 0.693867 10.31 0.942353 10.31H3.35024L0.27714 13.3924C0.189323 13.4795 0.119622 13.5832 0.0720559 13.6973C0.0244897 13.8115 0 13.934 0 14.0576C0 14.1813 0.0244897 14.3038 0.0720559 14.418C0.119622 14.5321 0.189323 14.6358 0.27714 14.7229C0.364239 14.8107 0.467863 14.8804 0.582035 14.9279C0.696208 14.9755 0.818669 15 0.942353 15C1.06604 15 1.1885 14.9755 1.30267 14.9279C1.41684 14.8804 1.52047 14.8107 1.60757 14.7229L4.69004 11.6404V14.0576C4.69004 14.3061 4.78875 14.5444 4.96446 14.7201C5.14016 14.8959 5.37847 14.9946 5.62696 14.9946C5.87544 14.9946 6.11375 14.8959 6.28946 14.7201C6.46517 14.5444 6.56388 14.3061 6.56388 14.0576V9.37304C6.56388 9.12456 6.46517 8.88625 6.28946 8.71054C6.11375 8.53483 5.87544 8.43612 5.62696 8.43612Z"
            fill="#5C5C5C"
          />
        </svg>
        {{ allCollapsed ? 'Expand All' : 'Collapse All' }}
      </a>
      <a (click)="openPopup(null)" pTooltip="Add Classification Setting" tooltipPosition="left" class="add-plus">
        <img src="assets/img/add-plus.svg" width="17" alt="filters" />
      </a>
    </div>
  </div>

  <div class="classification-new__content">
    <div class="classification-new__list-outer">
      <div class="classification-new__list-header">
        <div class="column-box">Classification</div>
        <div class="column-box displayname">Display Name</div>
        <div class="column-box">WIP State & Assigned To</div>
        <div class="column-box text-center">Facility Duration <br />(In Minutes)</div>
        <div class="column-box text-center">Remote Duration<br />(In Minutes)</div>
        <div class="column-box text-center">Road/Home Duration<br />(In Minutes)</div>
        <div class="column-box text-center">Inventory Location</div>
        <div class="column-box text-center">Allow Max.<br />Appointment Limit</div>
        <div class="column-box text-center">Appointment(s)<br />Per Day</div>
        <div class="column-box text-center" *ngIf="showUpdatePODStatus">Update POD<br />Status</div>
        <div class="column-box text-center action-menu">Action</div>
      </div>

      <div class="classification-new__list-content">
        <div class="list-row" *ngFor="let classification of items">
          <div class="column-box">
            <div class="classification-text">
              {{ classification.crmClassificationType }}
              <span>30 Minutes <i class="p-element info-new" pTooltip="15 Minutes" tooltipPosition="right"></i></span>
            </div>
          </div>
          <div class="column-box displayname">
            <span class="display-name">{{ classification.crmClassificationDisplayName }}</span>
          </div>
          <div class="column-box">
            <div class="classification-text">
              {{ classification.crmWIPStatusNameBT }}
              <span>{{ classification.crmWIPAssignedToPerson }}</span>
            </div>
          </div>
          <div class="column-box text-center">{{ classification.crmFacilityClassificationDuration }}</div>
          <div class="column-box text-center">{{ classification.crmRemoteClassificationDuration }}</div>
          <div class="column-box text-center">{{ classification.crmRoadHomeClassificationDuration }}</div>
          <div class="column-box text-center">{{ classification.invetoryLocationName }}</div>
          <div class="column-box text-center">{{ classification.crmIsEnableAppointmentMaxLimit ? 'Yes' : 'No' }}</div>
          <div class="column-box text-center">{{ classification.crmMaxNoOfAppointment }}</div>
          <div class="column-box text-center" *ngIf="showUpdatePODStatus">{{ classification.isUpdatePOD ? 'Yes' : 'No' }}</div>
          <div class="column-box text-center action-menu">
            <a class="actionmenu-btn" href="javascript:void(0)" (click)="op.toggle($event)">
              <svg _ngcontent-nwa-c189="" width="21" height="5" viewBox="0 0 21 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle _ngcontent-nwa-c189="" cx="2.5" cy="2.5" r="2.5" fill="#707070"></circle>
                <circle _ngcontent-nwa-c189="" cx="10.5" cy="2.5" r="2.5" fill="#707070"></circle>
                <circle _ngcontent-nwa-c189="" cx="18.5" cy="2.5" r="2.5" fill="#707070"></circle>
              </svg>
            </a>

            <p-overlayPanel class="table-action-popup" appendTo="body" #op>
              <ul class="quick-link-menu">
                <li>
                  <a class="edit-row" style="margin-left: 0" href="javascript:void(0)" (click)="openPopup(classification)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="103.901" height="98.574" viewBox="0 0 103.901 98.574">
                      <g id="edit-icon-new" transform="translate(-52.983 -52.983)">
                        <path
                          id="Path_3"
                          data-name="Path 3"
                          d="M323.731,72.125l13.32,13.313ZM332.3,60.4,296.28,96.412a13.319,13.319,0,0,0-3.648,6.8l-3.327,16.653,16.653-3.333a13.305,13.305,0,0,0,6.8-3.641l36.016-36.016A11.655,11.655,0,1,0,332.3,60.4Z"
                          transform="translate(-202.246)"
                          fill="none"
                          stroke="#6f64a7"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="8"
                        />
                        <path
                          id="Path_4"
                          data-name="Path 4"
                          d="M152.884,117.371v18.115a11.745,11.745,0,0,1-3.745,8.539,13.177,13.177,0,0,1-9.041,3.537H69.769a13.179,13.179,0,0,1-9.042-3.537,11.746,11.746,0,0,1-3.745-8.539V69.066a11.746,11.746,0,0,1,3.745-8.539,13.178,13.178,0,0,1,9.042-3.537H88.95"
                          transform="translate(0 -0.006)"
                          fill="none"
                          stroke="#6f64a7"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="8"
                        />
                      </g>
                    </svg>
                    Edit</a
                  >
                </li>
                <li>
                  <a class="edit-row" href="javascript:void(0)" (click)="delete(classification)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="30" viewBox="0 0 26 30">
                      <g id="delete-icon-new" transform="translate(-3 -1)">
                        <path
                          id="Path_1"
                          data-name="Path 1"
                          d="M24,31H8a3,3,0,0,1-3-3V9A1,1,0,0,1,7,9V28a1,1,0,0,0,1,1H24a1,1,0,0,0,1-1V9a1,1,0,0,1,2,0V28a3,3,0,0,1-3,3Z"
                          fill="#6f64a7"
                        />
                        <path id="Path_2" data-name="Path 2" d="M28,7H4A1,1,0,0,1,4,5H28a1,1,0,0,1,0,2Z" fill="#6f64a7" />
                        <path
                          id="Path_3"
                          data-name="Path 3"
                          d="M20,7a1,1,0,0,1-1-1V3H13V6a1,1,0,0,1-2,0V2a1,1,0,0,1,1-1h8a1,1,0,0,1,1,1V6A1,1,0,0,1,20,7Z"
                          fill="#6f64a7"
                        />
                        <path id="Path_4" data-name="Path 4" d="M16,26a1,1,0,0,1-1-1V11a1,1,0,0,1,2,0V25A1,1,0,0,1,16,26Z" fill="#6f64a7" />
                        <path id="Path_5" data-name="Path 5" d="M21,24a1,1,0,0,1-1-1V13a1,1,0,0,1,2,0V23A1,1,0,0,1,21,24Z" fill="#6f64a7" />
                        <path id="Path_6" data-name="Path 6" d="M11,24a1,1,0,0,1-1-1V13a1,1,0,0,1,2,0V23A1,1,0,0,1,11,24Z" fill="#6f64a7" />
                      </g>
                    </svg>
                    Delete</a
                  >
                </li>
              </ul>
            </p-overlayPanel>
          </div>

          <div class="collapse-box" [class.collapse]="classification.collapsed">
            <div class="collapse-box__header">
              <h3 (click)="classification.collapsed = !classification.collapsed">
                <svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.2422 8.53932L7.24219 3.53932L2.24219 8.53932L0.242188 7.53932L7.24219 0.539321L14.2422 7.53932L12.2422 8.53932Z" fill="#8D8D8D" />
                </svg>
                Black Out Days Information
              </h3>
            </div>
            <div class="collapse-box__content">
              <div class="black-out-days-information">
                <div class="black-out-days-information__box" *ngFor="let config of classification.blackoutConfig">
                  <h3>{{ config.visitTypeName }}</h3>

                  <span>
                    <label>Black Out Day(s)</label>
                    <span>{{ config.blackoutDays }}</span>
                  </span>
                  <span>
                    <label>Include Weekends</label>
                    <span>{{ config.includeWeekend ? 'Yes' : 'No' }}</span>
                  </span>
                  <span>
                    <label>Applicable for</label>
                    <span>{{ config.applicableForName }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="loader-block" *ngIf="loading" style="z-index: 10000 !important">
    <p-progressSpinner [style]="{ width: '50px', height: '50px' }" strokeWidth="8" fill="#ffffff" animationDuration=".8s"> </p-progressSpinner>
  </div>
</div>
